import { render } from "./mainMenuView.vue?vue&type=template&id=dff40450&scoped=true"
import script from "./mainMenuView.vue?vue&type=script&lang=js"
export * from "./mainMenuView.vue?vue&type=script&lang=js"

import "./mainMenuView.vue?vue&type=style&index=0&id=dff40450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff40450"]])

export default __exports__